"use client";

import { c as _c } from "react/compiler-runtime";
import { useElementOnScreen } from "@/hooks/useElementOnScreen";
import { clsx } from "clsx";
import { Calculator, CheckCircle, ClipboardCheck, FileText, Shield } from "lucide-react";
import { useTranslations } from "next-intl";
import NextImage from "next/image";
import { ReactNode } from "react";
const icons: ReactNode[] = [<ClipboardCheck className="w-8 h-8" key="clipboard" />, <CheckCircle className="w-8 h-8" key="check" />, <FileText className="w-8 h-8" key="file" />, <Calculator className="w-8 h-8" key="calculator" />, <Shield className="w-8 h-8" key="shield" />];
export function Prestations() {
  const $ = _c(30);
  const {
    containerRef,
    isVisible
  } = useElementOnScreen();
  const t = useTranslations("prestations");
  const t0 = isVisible && "visible";
  let t1;
  if ($[0] !== t0) {
    t1 = clsx("fade-in-left", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h2 className="text-4xl md:text-5xl font-serif mb-4">{t2}</h2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("intro");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <p className="max-w-xl text-white-cream/75 leading-relaxed mb-8">{t4}</p>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="line-accent bg-terracotta mb-8" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("imageAlt");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="rounded-2xl aspect-[4/3] overflow-hidden relative shadow-2xl mb-8"><NextImage src="/images/illustrations/illustration-architecture.jpg" alt={t7} loading="eager" fill={true} className="object-cover" sizes="(max-width: 1024px) 100vw, 50vw" /></div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t5 || $[18] !== t8) {
    t9 = <div className={t1}>{t3}{t5}{t6}{t8}</div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [0, 1, 2, 3, 4];
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isVisible || $[22] !== t) {
    t11 = <div className="space-y-6">{t10.map(index => <div key={index} className={clsx("fade-in-right flex gap-6 p-6 rounded-xl bg-forest-green-light/30 hover:bg-forest-green-light/50 transition-colors duration-300 cursor-pointer group", isVisible && "visible")} style={{
        transitionDelay: `${index * 100}ms`
      }}><div className="text-terracotta group-hover:scale-110 transition-transform duration-300">{icons[index]}</div><div><h3 className="text-lg font-semibold mb-2">{t(`services.${index}.title`)}</h3><p className="text-white-cream/70 text-sm">{t(`services.${index}.description`)}</p></div></div>)}</div>;
    $[21] = isVisible;
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <div className="max-w-7xl mx-auto px-6"><div className="grid lg:grid-cols-2 gap-16 items-center">{t9}{t11}</div></div>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== containerRef || $[28] !== t12) {
    t13 = <section id="prestations" ref={containerRef} className="py-24 bg-forest-green text-white-cream">{t12}</section>;
    $[27] = containerRef;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}